import { LogOut, SlidersHorizontal, ZoomIn } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui";
import { ROUTES } from "@/constants/routes";
import { useGetMe } from "@/services/api-hooks/user";
import { gtmService } from "@/services/gtm-service";
import { useAuthStore } from "@/store/auth.store";

import { ProfileHeader } from "./components/ProfileHeader";
import { ProfileMenuLinkRow } from "./components/ProfileMenuLinkRow";

export const Profile = () => {
  const { data: user } = useGetMe();
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate(ROUTES.HOME);
  };

  useEffect(() => {
    gtmService.trackProfileView();
  }, []);

  return (
    <div className="mx-auto w-full max-w-xl px-4 py-8 sm:px-6">
      <ProfileHeader email={user?.email} name={user?.name} />

      <div className="mt-8 space-y-3">
        <ProfileMenuLinkRow
          to={ROUTES.PROFILE_SETTINGS}
          icon={<SlidersHorizontal className="h-5 w-5" />}
        >
          Settings
        </ProfileMenuLinkRow>
        <ProfileMenuLinkRow
          to={ROUTES.PROFILE_SUBSCRIPTION}
          icon={<ZoomIn className="h-5 w-5" />}
        >
          Manage Subscription
        </ProfileMenuLinkRow>
        <Button
          variant="outline"
          onClick={handleLogout}
          size="lg"
          className="w-full text-red-600 md:hover:border-red-100 md:hover:bg-red-50"
        >
          <LogOut />
          Log Out
        </Button>
      </div>
    </div>
  );
};
